import Notification from './Notification';

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notification/index.js